export const areSetsEqual = (
  setA: Set<unknown>,
  setB: Set<unknown>,
): boolean => {
  if (setA.size !== setB.size) {
    return false;
  }

  for (const elem of setA) {
    if (!setB.has(elem)) {
      return false;
    }
  }

  return true;
};
